import { Button, styled } from '@mui/material';

const StyledSessionDetailsDialogButton = styled(Button)(({ theme }) => ({
  fontSize: theme.typography.pxToRem(12),
  paddingBottom: theme.spacing(0.5),
  paddingTop: theme.spacing(0.5)
}));

export default StyledSessionDetailsDialogButton;
